module.exports = __webpack_public_path__ + "img/file-earmark-ppt-fill.8167e09a.svg";